/**
 * Hack around this issue with ui-mask on android devices
 * https://github.com/angular-ui/ui-utils/issues/189
 */
import angular from 'angular';

export default angular
  .module('app.directives.ui-mask-android-override', [])
  .directive('uiMaskAndroidOverride', UiMaskAndroidOverrideDirective);

function UiMaskAndroidOverrideDirective($window) {
  function isAndroidDevice() {
    let userAgentMatch = $window.navigator.userAgent.match(
      '.*Android+.*Mobile.*'
    );
    return typeof userAgentMatch !== 'undefined' && userAgentMatch !== null;
  }

  function parser(vvalue) {
    return vvalue.replace(/[^0-9]/g, '');
  }

  function link(scope, element, attrs, controller) {
    if (isAndroidDevice()) {
      element.attr('placeholder', attrs.uiMask);
      element.removeAttr('ui-mask');

      //remove ui-mask before it gets initalized.
      if (attrs.hasOwnProperty('uiMask')) {
        delete attrs['uiMask'];
      }
      controller.$parsers.push(parser);
    }
  }

  return {
    priority: 300, //higher than uiMask
    restrict: 'A',
    require: 'ngModel',
    link,
  };
}
